import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import { House } from "./houses.model";
import { Observable } from "rxjs/Observable";
import { ContractedPowerDTO } from "../../shared/DTO/ContractedPowerDTO";

@Injectable()
export class HousesService {
  constructor(private apiService: ApiService) {}

  getHouses(): Observable<any> {
    return this.apiService.get("/equipment/houses/").map((houses) => {
      return House.fromDTO(houses);
    });
  }

  getHouseTariff(houseId: string): Observable<any> {
    return this.apiService.get(`/equipment/houses/${houseId}/housetariff`);
  }

  getHouseContractedPower(houseId: string): Observable<any> {
    return this.apiService.get<ContractedPowerDTO>(
      `/equipment/houses/${houseId}/contractedpower`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/houses/houses.service.ts